import { gql, useQuery } from '@apollo/client';
import { useAuthToken } from './useAuthToken';

const queryIdentity = gql`
    query GetIdentity {
        intercomIdentity
    }
`;

type QueryResponse = {
  intercomIdentity: string;
}

export function useIntercomIdentity() {
  const { token } = useAuthToken();
  const { data } = useQuery<QueryResponse>(queryIdentity, { skip: !token });

  return data?.intercomIdentity;
}
